import { useAuthStore } from "#imports";
import { usePageStore } from "#imports";
import { storeToRefs } from 'pinia';

const authStore = useAuthStore();
const { isDemo, isLoggedIn, profile } = storeToRefs(authStore);
const { fetchLinkCodes, fetchProfile, loadSession, resetStores } = authStore;
const { changesExist, isForceNav, isWarningShown, prevRoute, tempNavTo } = storeToRefs(usePageStore());
const _url = useRequestURL();
isDemo.value = _url.pathname.includes('/demo/');

export default defineNuxtRouteMiddleware(async (to, from) => {
    const errorMsg = await loadSession();
    if (errorMsg === '') {
        await fetchProfile();
        await fetchLinkCodes();
    }

    if (to?.name !== "login") {
        prevRoute.value = to.path;
    }

    if (!isDemo.value) {
        /* Public access */
        if (!isLoggedIn.value && to?.name?.toString() !== 'login' && to?.name?.toString() !== 'index' && to?.name?.toString() !== 'register' && to?.name?.toString() !== 'password-reset') {
            abortNavigation();
            await resetStores();
            return navigateTo('/');
        }
        /* User access */
        else if (isLoggedIn.value
            && (to?.name?.toString() === 'index' || to?.name?.toString() === 'login' || to?.name?.toString() === 'register')) {
            abortNavigation();
            return navigateTo('/account');
        }
    }
 
    if (changesExist.value && !isForceNav.value) {
        isWarningShown.value = true;
        tempNavTo.value = to;
        return abortNavigation();
    }
    else {
        changesExist.value = false;
        isForceNav.value = false;
        isWarningShown.value = false;
        tempNavTo.value = null;
        if (to.name === 'login') {
            resetStores();
        }
    }
});